/**
 * Created by Ethan on 16/12/23.
 */

const Util = {

    /*
     * fetch简单封装
     * url: 请求的URL
     * successCallback: 请求成功回调
     * failCallback: 请求失败回调
     * 
     * */
    get: (url, successCallback, failCallback) => {
        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                successCallback(JSON.parse(responseText));
            })
            .catch((err) => {
                failCallback(err);
            });
    },

    post: (url, params, successCallback, failCallback) => {

        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: params
        })
            .then((response) => response.json())
            .then((responseJson) => {
                //console.log(responseJson);
                //const returnCode = responseJson.returnCode;
                //if (returnCode == WebService.RETURN_CODE_EXPIRED) {
                //    // Token过期，重新获取token并执行该请求。
                //    _postByNewToken(url, params, successCallback, failCallback);
                //} else {
                successCallback(responseJson);
                //}
            })
            .catch((error) => {
                console.error(error);
                failCallback(error);
            });
    },
    _isMobile: () => {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        return flag;
    },
    isWeChat: () => {
        const ua = navigator.userAgent.toLowerCase();
        const isWeChat = /micromessenger/i.test(ua); // 是否在微信环境
        return isWeChat
    },
    cleanObject: (obj) => {
        if (Array.isArray(obj)) {
            return obj
                .map(item => Util.cleanObject(item))
                .filter(item => item !== null && item !== undefined && item !== '' && !(Array.isArray(item) && item.length === 0));
        } else if (typeof obj === 'object' && obj !== null) {
            return Object.keys(obj)
                .reduce((acc, key) => {
                    const value = Util.cleanObject(obj[key]);
                    if (value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)) {
                        acc[key] = value;
                    }
                    return acc;
                }, {});
        }
        return obj;
    },


}

// 日期格式化
//Date.prototype.format = function (format) {
//    var o = {
//        "M+": this.getMonth() + 1, //month
//        "d+": this.getDate(),   //day
//        "h+": this.getHours(),  //hour
//        "m+": this.getMinutes(), //minute
//        "s+": this.getSeconds(), //second
//        "q+": Math.floor((this.getMonth() + 3) / 3), //quarter
//        "S": this.getMilliseconds() //millisecond
//    }
//    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
//        (this.getFullYear() + "").substr(4 - RegExp.$1.length));
//    for (var k in o)if (new RegExp("(" + k + ")").test(format))
//        format = format.replace(RegExp.$1,
//            RegExp.$1.length == 1 ? o[k] :
//                ("00" + o[k]).substr(("" + o[k]).length));
//    return format;
//}

export default Util;